<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>ECOSYSTEM</div>
				<h2 waHeading="l" waText>Plugin &amp; Component Catalog</h2>
				<p waBody="m" waColorText="quiet" waText>Production-ready modules for every use case.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_14"></markdown>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="brand">40 Plugins</wa-tag>
					<wa-tag pill variant="neutral">11 Categories</wa-tag>
					<wa-tag pill variant="success">5 UI Frameworks</wa-tag>
					<wa-tag pill variant="success">JPMS Modular</wa-tag>
				</div>
				<div class="wa-cluster wa-gap-s">
					<wa-button [routerLink]="['/frameworks']" appearance="outlined" variant="brand">UI Frameworks &rarr;</wa-button>
				</div>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="rendering-ui">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Rendering &amp; UI</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>JWebMP Core</h3>
						<p waBody="s" waColorText="quiet" waText>Strongly-typed HTML/CSS/JS component model</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>JWebMP 2.0.0-SNAPSHOT</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Guice 7</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/core']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>JWebMP Client</h3>
						<p waBody="s" waColorText="quiet" waText>Client SPI contracts</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>JWebMP 2.0.0-SNAPSHOT</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Guice 7</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/client']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="angular-generation">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Angular Generation</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Angular Plugin</h3>
						<p waBody="s" waColorText="quiet" waText>Generates complete Angular 21 TypeScript projects from Java annotations</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Angular 20</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">STOMP/WebSocket</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/angular']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Angular Maven Plugin</h3>
						<p waBody="s" waColorText="quiet" waText>Maven build plugin that drives the full Angular build lifecycle</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Maven / Angular CLI 3.9.6+ / 20</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Maven Plugin</wa-tag>
							<wa-tag pill variant="neutral">Angular CLI</wa-tag>
							<wa-tag pill variant="neutral">Docker</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/angular-maven-plugin']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>TypeScript Client Annotations</h3>
						<p waBody="s" waColorText="quiet" waText>Annotation library for describing Angular metadata in Java</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Angular / TypeScript 20 / 5</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/typescript-client']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Angular Forms</h3>
						<p waBody="s" waColorText="quiet" waText>Angular Forms</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Angular Forms 2.0.0-SNAPSHOT</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/angular-forms']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="data-grids">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Data &amp; Grids</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Grid</h3>
						<p waBody="s" waColorText="quiet" waText>Feature-rich data grid &#40;AG Grid 35.0.0&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Grid 35.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Grid 35.0.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/aggrid']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Grid Enterprise</h3>
						<p waBody="s" waColorText="quiet" waText>Enterprise grid features</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Grid Enterprise 35.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Grid Enterprise 35.0.0</wa-tag>
							<wa-tag pill variant="neutral">AG Charts 13.0.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/aggrid-enterprise']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>DataTables</h3>
						<p waBody="s" waColorText="quiet" waText>DataTables.net 2.3.8</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>DataTables.net 2.3.8</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">DataTables 2.3.8</wa-tag>
							<wa-tag pill variant="neutral">jQuery 4.0.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/datatables']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="charts-visualisation">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Charts &amp; Visualisation</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Charts</h3>
						<p waBody="s" waColorText="quiet" waText>Enterprise charting &#40;AG Charts 13.1.0&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Charts 13.1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Charts 13.1.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/agcharts']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>AG Charts Enterprise</h3>
						<p waBody="s" waColorText="quiet" waText>Advanced chart types</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>AG Charts Enterprise 13.1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">AG Charts Enterprise 13.1.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/agcharts-enterprise']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Chart.js</h3>
						<p waBody="s" waColorText="quiet" waText>Lightweight charting with Chart.js</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Chart.js 2.x</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Chart.js</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/chartjs']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>C3.js</h3>
						<p waBody="s" waColorText="quiet" waText>C3 makes it easy to generate D3-based charts by wrapping the code required to construct the entire chart.</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>C3.js 0.7.20</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">C3 0.7.20</wa-tag>
							<wa-tag pill variant="neutral">D3-based</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/c3']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>D3.js</h3>
						<p waBody="s" waColorText="quiet" waText>D3.js is a JavaScript library for manipulating documents based on data using HTML, SVG, and CSS.</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>D3.js 7.9.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">D3 7.9.0</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/d3']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>jqPlot</h3>
						<p waBody="s" waColorText="quiet" waText>jqPlot is a versatile and expandable jQuery plotting plugin with customizable renderers for lines, bars, pies, bubbles, donuts, and more.</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>jqPlot 1.0.9</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">jqPlot 1.0.9</wa-tag>
							<wa-tag pill variant="neutral">jQuery</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/jqplot']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Easy Pie Chart</h3>
						<p waBody="s" waColorText="quiet" waText>Lightweight plugin to render simple, animated and retina optimized pie charts for single values using HTML5 Canvas.</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Easy Pie Chart 2.1.7</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Easy Pie Chart 2.1.7</wa-tag>
							<wa-tag pill variant="neutral">Canvas</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/easy-pie-chart']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="scheduling">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Scheduling</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>FullCalendar</h3>
						<p waBody="s" waColorText="quiet" waText>Full-featured calendar &#40;FullCalendar 6.1.19&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>FullCalendar 6.1.19</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">FullCalendar 6.1.19</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fullcalendar']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>FullCalendar Pro</h3>
						<p waBody="s" waColorText="quiet" waText>Premium calendar features</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>FullCalendar Pro 6.1.19</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">FullCalendar Pro 6.1.19</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fullcalendar-pro']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="icons">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Icons</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Font Awesome</h3>
						<p waBody="s" waColorText="quiet" waText>Font Awesome Free 7.2.0</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Font Awesome 7.2.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Font Awesome 7.2.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fontawesome']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Font Awesome Pro</h3>
						<p waBody="s" waColorText="quiet" waText>Font Awesome Pro 7.2.0</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Font Awesome Pro 7.2.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Font Awesome Pro 7.2.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/fontawesome-pro']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Themify Icons</h3>
						<p waBody="s" waColorText="quiet" waText>Themify Icons</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Themify Icons 3.4</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Themify Icons 3.4</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/themify-icons']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Material Icons &#40;MDI&#41;</h3>
						<p waBody="s" waColorText="quiet" waText>Material Design Icons &#40;Community&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Material Design Icons &#40;Community&#41; 2.4.85</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">MDI 2.4.85</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/material-icons']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Material Design Icons &#40;Google&#41;</h3>
						<p waBody="s" waColorText="quiet" waText>Google Material Design Icons</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Google Material Design Icons 3.0.1</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Material Icons 3.0.1</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/material-design-icons']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Weather Icons</h3>
						<p waBody="s" waColorText="quiet" waText>Weather Icons</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Weather Icons 2.2</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Weather Icons 2.2</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/weather-icons']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Glyphicons</h3>
						<p waBody="s" waColorText="quiet" waText>Glyphicons Halflings</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Glyphicons 1.9.2</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Glyphicons 1.9.2</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/glyphicons']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Skycons</h3>
						<p waBody="s" waColorText="quiet" waText>Skycons</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Skycons 1.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Skycons 1.0.0</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
							<wa-tag pill variant="neutral">Canvas</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/skycons']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="animation">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Animation</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Easing Effects</h3>
						<p waBody="s" waColorText="quiet" waText>33 easing timing functions from easings.net</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Easing / easings.net 1.4.1</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Easing 1.4.1</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/easing']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Waves Effect</h3>
						<p waBody="s" waColorText="quiet" waText>Material-design inspired click/tap ripple effect using Waves.js</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Waves.js 0.7.6</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Waves 0.7.6</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/waves']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="libraries">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Libraries</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>jQuery</h3>
						<p waBody="s" waColorText="quiet" waText>jQuery 4.0.0 integration</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>jQuery 4.0.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">jQuery 4.0.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/jquery']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Globalize</h3>
						<p waBody="s" waColorText="quiet" waText>Internationalization and localization using Globalize.js and Unicode CLDR data.</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Globalize.js 1.2.2</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Globalize 1.2.2</wa-tag>
							<wa-tag pill variant="neutral">Unicode CLDR</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/globalize']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Google Code Prettify</h3>
						<p waBody="s" waColorText="quiet" waText>Google Code Prettify</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Google Code Prettify 0.1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Code Prettify 0.1.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/prettify']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>jQuery WayPoints</h3>
						<p waBody="s" waColorText="quiet" waText>jQuery Waypoints</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>jQuery Waypoints 4.0.1</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Waypoints 4.0.1</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/waypoints']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Plus As Tab</h3>
						<p waBody="s" waColorText="quiet" waText>Plus As Tab</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>PlusAsTab 0.2.2</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">PlusAsTab 0.2.2</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/plus-as-tab']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>PrismJS</h3>
						<p waBody="s" waColorText="quiet" waText>PrismJS</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>PrismJS 1.30.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">PrismJS 1.30.0</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/prism']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>NGX Markdown</h3>
						<p waBody="s" waColorText="quiet" waText>NGX Markdown</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>NGX Markdown 21.1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">NGX Markdown 21+</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/ngx-markdown']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="real-time-messaging">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Real-Time Messaging</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>RabbitMQ Comms</h3>
						<p waBody="s" waColorText="quiet" waText>Bidirectional browser-to-server messaging via RabbitMQ</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>RabbitMQ / STOMP.js / SockJS 3.x</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">RabbitMQ 3.x</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">STOMP</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/rabbitmq']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="runtime-server">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Runtime &amp; Server</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>JWebMP Vert.x</h3>
						<p waBody="s" waColorText="quiet" waText>Vert.x 5 HTTP connector</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Eclipse Vert.x 5</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
							<wa-tag pill variant="neutral">Guice 7</wa-tag>
							<wa-tag pill variant="neutral">Maven 4</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/vertx']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Local Storage Security</h3>
						<p waBody="s" waColorText="quiet" waText>Local Storage Security</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>JWebMP Local Storage 1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
							<wa-tag pill variant="neutral">WebSocket</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/localstorage']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Session Storage Security</h3>
						<p waBody="s" waColorText="quiet" waText>Session Storage Security</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>JWebMP Session Storage 1.0</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
							<wa-tag pill variant="neutral">WebSocket</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/sessionstorage']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="notifications">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Notifications</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-s">
						<h3 waHeading="m" waText>Toastr</h3>
						<p waBody="s" waColorText="quiet" waText>Toastr</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Toastr 2.1.4</div>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">Java 25+</wa-tag>
							<wa-tag pill variant="neutral">Toastr 2.1.4</wa-tag>
							<wa-tag pill variant="neutral">Angular 21</wa-tag>
							<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						</div>
						<wa-button [routerLink]="['/plugins/toastr']" appearance="outlined" variant="brand">View Details</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>